// extracted by mini-css-extract-plugin
export default {"filter":"QayCTXSO3KkW9EsytDTVqQ==","label":"hpy0yibhUvh-2q4NyqSkGg== body-standard"};